<template>
  <div>
    <GeneratePayOrder
      :isOpen.sync="isGeneratePayOrderPanelOpen"
      v-bind:invoice="invoicesTable.selected"
      @updateInvoices="loadInvoices()"/>
    <RelatePayOrder
      :isOpen.sync="isRelatePayOrderPanelOpen"
      v-bind:invoice="invoiceToRelate"
      @updateInvoices="updateInvoicesTable(this.invoicesTable.options)"/>

    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <!-- <div class="title primary--text">{{ section }}</div> -->
      <v-spacer />
      <div class="d-flex justify-end align-center">
        <!-- <div>
          <v-text-field
            v-model="search"
            class="mr-3"
            append-icon="mdi-magnify"
            :label="$t('expenses.registerMovements.inputSearchLabel')"
            solo
            rounded
            hide-details
            flat
            dense/>
        </div> -->
        <div class="mr-3" v-if="movementsPermissions['generate-pay-order']">
          <v-btn
            color="primary"
            depressed
            :disabled="!this.invoicesTable.selected.length"
            @click="openGeneratePayOrderPanel"
          >
            {{ $t('expenses.registerMovements.invoices.buttonGenerate') }}
          </v-btn>
        </div>
      </div>
    </div>

    <v-flex xs12>
      <v-data-table
        v-model="invoicesTable.selected"
        :loading-text="invoicesTable.title"
        :loading="invoicesTable.loading"
        :headers="invoicesTable.headers"
        :items="invoicesTable.data"
        :options="invoicesTable.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        :server-items-length="invoicesTable.total"
        class="elevation-1"
        @update:options="updateInvoicesTable">
        <template v-slot:top>
          <div class="px-3">
            <v-row>
              <v-col cols="12" md="3">
                <div class="d-flex align-center">
                  <span class="mr-3">
                    Filtros:
                  </span>
                  <v-menu
                    ref="datePicker"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="downloadDates"
                        label="Rango de fechas"
                        prepend-icon="mdi-calendar"
                        outlined
                        rounded
                        readonly
                        hide-details
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="downloadDates"
                      ref="picker"
                      color="primary"
                      range
                      :first-day-of-week="1"
                      :allowed-dates="allowedDates"
                      @input="orderDateRange"
                      reactive
                      no-title
                      :locale="locale"
                    >
                      <div>
                        <div class="d-flex">
                          <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                          <v-spacer/>
                          <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                          <v-btn :disabled="downloadDates.length < 2" color="primary" @click="confirmDownload">OK</v-btn>
                        </div>
                      </div>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  solo
                  rounded
                  dense
                  clearable
                  v-model="issuerTaxid"
                  @change="loadInvoices"
                  @click:clear="resetData(1)"
                  :disabled="downloadDates.length < 2"
                  :label="$t('expenses.registerMovements.invoices.downloadDialog.issuerTaxIdLabel')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  solo
                  rounded
                  dense
                  clearable
                  v-model="issuerName"
                  @change="loadInvoices"
                  @click:clear="resetData(2)"
                  :disabled="downloadDates.length < 2"
                  label="Buscar por proveedor"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  solo
                  rounded
                  dense
                  label="Tipos de factura"
                  :items="invoiceTypes"
                  item-text="name"
                  item-value="value"
                  v-model="invoiceType"
                  @change="loadInvoices"
                />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <v-simple-checkbox
            v-if="item.selectable && item.items.length"
            @input="toggleInvoice(item)"
            :value="isSelectedInvoice(item)"
            :ripple="false"
          />
          <span v-else-if="!item.items.length" class="grey--text">
            En proceso de extracción
          </span>
          <span v-else-if="item.expenses" class="primary--text">
            Relacionada
          </span>
          <span v-else class="secondary--text">
            Costo
          </span>
        </template>
        <template v-slot:[`item.uuid`]="{ item }">
          <div>
            <v-progress-circular
              v-if="loadingBtn && loadingBtn === item.id"
              indeterminate
              color="primary"
            />
            <a v-else href="" @click.prevent="openDetail(item)">{{ item.uuid }}</a>
          </div>
        </template>
        <template v-slot:[`item.issuer`]="{ item }">
          <div>
            {{ item.issuer.name }}
          </div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div class="text-right">
            {{ item.total | toFix2 | numberWithComma | prefix('$') }} {{ item.currency }}
          </div>
        </template>
        <template v-slot:[`item.issuedAt`]="{ item }">
          <div>
            {{ $moment(item.issuedAt).format('DD/MM/YYYY') }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div>
            {{ item.status }}
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }" v-if="movementsPermissions['relate-pay-order']">
          <div v-if="item.selectable && item.items.length" class="d-flex">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="primary"
                  fab
                  x-small
                  depressed
                  :loading="item.id === loadingBtn"
                  :disabled="disabled"
                  @click="openRelatePayOrderPanel(item)"
                >
                  <v-icon>mdi-stop</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('expenses.registerMovements.invoices.searchMatchs') }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <InvoiceViewer ref="invoiceViewer" />

    <v-dialog @keydown.esc="unlinkInvoiceDialog=false" v-model="unlinkInvoiceDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          {{ $t('expenses.registerMovements.invoices.unlinkInvoiceDialog.title') }}
        </v-card-title>
        <v-card-text>
          {{ $t('expenses.registerMovements.invoices.unlinkInvoiceDialog.text') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="unlinkInvoiceDialog = false">
            {{ $t('expenses.registerMovements.invoices.unlinkInvoiceDialog.buttonCancel') }}
          </v-btn>
          <v-btn color="black darken-1" text @click="unlinkInvoice">
            {{ $t('expenses.registerMovements.invoices.unlinkInvoiceDialog.buttonConfirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import moment from 'moment'
import { cloneDeep } from 'lodash'

import GeneratePayOrder from '@/components/sidePanels/GeneratePayOrder'
import RelatePayOrder from '@/components/sidePanels/RelatePayOrder'
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import getLocale from '@/lang/locale'

export default {
  name: 'InvoiceBox',
  components: {
    GeneratePayOrder,
    RelatePayOrder,
    InvoiceViewer
  },
  data () {
    return {
      datePicker: false,
      issuerName: '',
      overlay: false,
      section: this.$i18n.t('expenses.registerMovements.section'),
      invoicesTable: {
        title: this.$i18n.t('expenses.registerMovements.invoices.loading'),
        loading: false,
        headers: [
          { text: '', value: 'id', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.id'), value: 'uuid', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.supplier'), value: 'issuer', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.receiver'), value: 'receiver.name', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.amount'), value: 'total' },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.date'), value: 'issuedAt' },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.status'), value: 'status' },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.actions'), value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 30,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        },
        selected: []
      },
      search: '',
      unlinkInvoiceDialog: false,
      isRelatePayOrderPanelOpen: false,
      isGeneratePayOrderPanelOpen: false,
      downloadDates: [],
      invoice: null,
      invoiceType: 'I',
      invoiceTypes: [
        { name: 'Ingreso', value: 'I' },
        { name: 'Nómina', value: 'N' }
      ],
      issuerTaxid: '',
      invoices: {
        data: []
      },
      invoiceToRelate: null,
      loadingBtn: '',
      disabled: false
    }
  },
  computed: {
    restaurantTaxid () {
      return this.$store.state.currentRestaurant.taxInformation.data ? (this.$store.state.currentRestaurant.taxInformation.data.taxId || '') : ''
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    movementsPermissions () {
      return this.$store.state.login.permissions['expenses'].components['financial-movements'].actions
    }
  },
  watch: {
    // 'search': async function (val) {
    //   const params = {}
    //   if (val.length >= 3) {
    //     try {
    //       params.q = `/${val}/i`
    //       await this.load(params)
    //     } catch (error) {
    //       this.$toasted.show(error.message, { duration: 3000 })
    //     }
    //   } else {
    //     this.load(params)
    //   }
    // },
    'invoices.data': function () {
      this.invoicesTable.selected = []
      this.invoicesTable.data = this.invoices.data
    },
    '$store.state.currentRestaurant.data': async function (val) {
      this.resetForm()
    }
  },
  methods: {
    async resetData (options) {
      if (options === 1) this.issuerTaxid = ''
      if (options === 2) this.issuerName = ''
      await this.loadInvoices()
    },
    resetForm () {
      this.invoicesTable.data = []
      this.invoicesTable.total = 0
      this.invoicesTable.selected = []
      this.unlinkInvoiceDialog = false
      this.isRelatePayOrderPanelOpen = false
      this.isGeneratePayOrderPanelOpen = false
      this.downloadDates = []
      this.invoice = null
      this.invoiceType = 'I'
      this.invoices.data = []
      this.invoiceToRelate = null
      this.loadingBtn = ''
      this.disabled = false
    },
    openUnlinkInvoiceDialog (item) {
      this.invoice = item
      this.unlinkInvoiceDialog = true
    },
    async unlinkInvoice () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/invoices/${this.invoice.uuid}`)
        await this.loadInvoices()
        this.unlinkInvoiceDialog = false
        this.$toasted.show('La factura se ha desvinculado correctamente', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async getXml (id) {
      let xml = null
      this.disabled = true
      this.loadingBtn = id
      try {
        const { invoice } = await this.$api.get(`/v1/invoices/${id}/cfdi`)
        xml = invoice
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.disabled = false
      this.loadingBtn = ''
      return xml
    },
    async openDetail (item) {
      const invoice = cloneDeep(item)
      if (item.invoice) {
        item.xml = item.invoice
        await this.$refs.invoiceViewer.open(item)
      } else {
        invoice.xml = await this.getXml(item.id)
        await this.$refs.invoiceViewer.open(invoice)
      }
    },
    async resetDate () {
      this.downloadDates = []
      await this.loadInvoices()
      this.datePicker = false
    },
    async loadInvoices (params = null) {
      params = {
        startDate: moment(this.downloadDates[0]).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
        endDate: moment(this.downloadDates[1] || this.downloadDates[0]).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
        rfc: this.restaurantTaxid,
        issuerName: this.issuerName,
        status: 'VIGENTE',
        isIssuer: false,
        type: this.invoiceType,
        limit: this.invoicesTable.options.itemsPerPage,
        page: this.invoicesTable.options.page,
        rfcIssuer: this.issuerTaxid,
        ...params
      }
      this.invoicesTable.loading = true
      try {
        const response = await this.$api.get(`/v1/invoices`, params)
        this.invoicesTable.data = response.items.sort(i => i.selectable ? -1 : 1)
        this.invoicesTable.total = response.total
        this.datePicker = false
        // const { uuid } = this.invoicesTable.selected
        // this.invoicesTable.selected = uuid ? [ this.invoicesTable.data.find(item => item.uuid === uuid) ] : []
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.invoicesTable.loading = false
    },
    async updateInvoicesTable (options) {
      if (this.downloadDates.length) {
        const params = {
          startDate: moment(this.downloadDates[0]).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
          endDate: moment(this.downloadDates[1] || this.downloadDates[0]).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
          rfc: this.restaurantTaxid,
          status: 'VIGENTE',
          isIssuer: false,
          type: this.invoiceType,
          limit: options.itemsPerPage,
          page: options.page,
          sort: options.sortDesc[0] ? 'desc' : 'asc'
        }
        await this.loadInvoices(params)
      }
    },
    toggleInvoice (invoice) {
      const index = this.invoicesTable.selected.findIndex(i => i.id === invoice.id)

      this.invoicesTable.selected.pop()
      if (index < 0) {
        this.invoicesTable.selected.push(invoice)
      }
    },
    isSelectedInvoice (invoice) {
      return this.invoicesTable.selected.some(i => i.id === invoice.id)
    },
    openRelatePayOrderPanel (item) {
      this.invoiceToRelate = item
      this.isRelatePayOrderPanelOpen = true
    },
    openGeneratePayOrderPanel () {
      this.isGeneratePayOrderPanelOpen = true
    },
    confirmDownload () {
      this.loadInvoices()
    },
    allowedDates (val) {
      const nowDate = new Date()
      const evalDate = new Date(moment(val).format('YYYY-MM-DDTHH:mm:ss.SSS'))
      const len = this.downloadDates.length

      if (len) {
        if (len === 2) {
          return evalDate.getTime() <= nowDate.getTime()
        }
        const selectedDate = new Date(moment(this.downloadDates[0]).format('YYYY-MM-DDTHH:mm:ss.SSS'))
        const selectedDate2 = new Date(moment(this.downloadDates[0]).format('YYYY-MM-DDTHH:mm:ss.SSS'))
        const topLimitDate = new Date(selectedDate.setMonth(selectedDate.getMonth() + 1))
        const bottomLimitDate = new Date(selectedDate2.setMonth(selectedDate2.getMonth() - 1))

        return evalDate.getTime() <= nowDate.getTime() &&
          evalDate.getTime() <= topLimitDate.getTime() &&
          evalDate.getTime() >= bottomLimitDate.getTime()
      }

      return evalDate.getTime() <= nowDate.getTime()
    },
    orderDateRange () {
      this.downloadDates.sort((a, b) => new Date(a) - new Date(b))
    }
  }
}
</script>

<style lang="scss" scoped>
  .link:hover {
    text-decoration: underline;
    color: #3366BB !important;
  }

  .calendarTextField {
    height: 34px;
    width: 240px;
    border-radius: 22px;

    & ::v-deep .v-label {
      top: auto;
    }
  }

  .dateButton {
    text-transform: none;
  }
</style>
